var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "playlist-form-slide-in",
      attrs: {
        "modal-class": [
          "modal-right",
          {
            "modal-right-large":
              _vm.currentRouteName === "MediaPage" ||
              _vm.currentRouteName === "PlaylistForm"
          },
          { "modal-full": _vm.fullModal }
        ],
        id: "playlist-form-dialog",
        static: "",
        "hide-footer": "",
        "hide-header": ""
      },
      on: { show: _vm.init, hide: _vm.onHide, hidden: _vm.onHidden }
    },
    [
      _vm.show
        ? _c(
            "div",
            { attrs: { id: "hub-playlist-form" } },
            [
              _c(
                "transition",
                { attrs: { name: "fade", mode: "out-in" } },
                [_c("router-view")],
                1
              ),
              _vm._v(" "),
              _c("file-schedule-modal")
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }